import './style.scss';
import { useEffect, useState } from 'react';
import { Price } from 'utils/types';
import { formattingNumber } from 'utils';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledBundlePrice } from './style';
import { ActualPrice } from 'templates/Bundles/BundlePrice/ActualPrice';

export const AplBundlePrice = ({ price }: { price: Price }) => {
  const [finalPrice, setFinalPrice] = useState('');
  const [priceBeforeDiscount, setPriceBeforeDiscount] = useState('');

  useEffect(() => {
    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      true,
    );
    if (price.strokedPriceInCents) {
      const formattedPriceBeforeDiscount = formattingNumber(
        price?.strokedPriceInCents,
        price,
        price.isCents,
        price.multiplier,
        true,
      );
      setPriceBeforeDiscount(formattedPriceBeforeDiscount);
    }
    setFinalPrice(formattedPrice);
  }, [price]);

  return (
    <StyledBundlePrice
      direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
      className={'apl-bundle-2-price'}
    >
      <div>
        <AutoTextSize mode={'multiline'} maxFontSizePx={16}>
          <ActualPrice
            priceBeforeDiscount={priceBeforeDiscount}
            finalPrice={finalPrice}
            price={price}
          />
        </AutoTextSize>
      </div>
    </StyledBundlePrice>
  );
};
